import InfoSection from '../components/info_section';
// import ScrollButton from '../components/scroll_button';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/layout';
import styles from '../styles/compliance.module.scss'
import { useRouter } from 'next/router';
import { questionsList } from '../constants/compliance';
import { useState } from 'react';
import Plus from '../svgs/plus.svg';
import Minus from '../svgs/minus.svg';
import Image from 'next/image';

export default function Compliance () {
  const router = useRouter();
  const { t } = useTranslation('compliance');

  const [questions, setQuestions] = useState(new Array(questionsList.length).fill(false));

  const changeQuestion = key => setQuestions(prevState => prevState.map((question, index) => index === key ? !question : question));

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        {/* <ScrollButton scrollStepInPx='50' delayInMs='16.66' /> */}
        <InfoSection title='Compliance' description='complianceDescription' documentationLink='https://help.icdc.io/compliance/' lang={router.locale} />
        <div className={`${styles.security} flex`}>
          <h2>{t('security')}</h2>
          <p>{t('securityDescription')}</p>
        </div>
        <section className={'flex ' + styles.key_features}>
          <h2>{t('keysFeatures')}</h2>
          <p>{t('feature1')}</p>
          <p>{t('feature2')}</p>
        <div className={styles.dashboardImg}>
          <Image src={'/dashboard.webp'} alt='Dashboard' width={380} height={287} unoptimized loading='lazy' />
        </div>
        </section>
        <section className={'container ' + styles.simple_and_fast}>
          <h2>{t('simpleAnfFast')}</h2>
          <div className='flex col'>
            <div className={styles['vertical-line']} />
            <div className='flex row'>
              <div className={'flex ' + styles.circle}>1</div>
              <p>{t('step1')}</p>
            </div>
            <div className='flex row'>
              <div className={'flex ' + styles.circle}>2</div>
              <p>{t('step2')}</p>
            </div>
            <div className='flex row'>
              <div className={'flex ' + styles.circle}>3</div>
              <p>{t('step3')}</p>
            </div>
          </div>
        </section>
        <div className={'flex col ' + styles.schedule}>
          <h2>{t('schedule')}</h2>
          <p>{t('scheduleDescription')}</p>
        </div>
        <div className={'flex col ' + styles.faq}>
        <h3>{t('askedQuestion')}</h3>
          <div className={'flex ' + styles.faq__list}>
            {
              questionsList.map((question, key) => <div key={key} className={'flex ' + styles.question}>
                <div className='flex' onClick={() => changeQuestion(key)}>
                  <Image src={questions[key] ? Minus : Plus} alt={t("expandCollapseAlt")} />
                  <p>{t(question.questionText)}</p>
                </div>
                {questions[key] && <p dangerouslySetInnerHTML={{__html: t(question.answer, { interpolation: { escapeValue: false }})}} />}
              </div>)
            }
          </div>
        </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['compliance', 'common']),
  },
});
